const EndedArrowUp = () => (
  <>
    <path
      fill="currentColor"
      d="M18.5 4q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356A.49.49 0 0 1 18.5 5h-13a.48.48 0 0 1-.356-.144A.49.49 0 0 1 5 4.499q0-.213.144-.356A.49.49 0 0 1 5.5 4zm-6.498 4.021q.16 0 .296.053t.268.184l3.388 3.388a.5.5 0 0 1 .15.345.47.47 0 0 1-.15.363.5.5 0 0 1-.354.16.5.5 0 0 1-.354-.16L12.5 9.608V19.5q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.48.48 0 0 1-.143-.356V9.608l-2.746 2.746a.5.5 0 0 1-.344.15.47.47 0 0 1-.364-.15.5.5 0 0 1-.16-.354.5.5 0 0 1 .16-.354l3.389-3.388a.8.8 0 0 1 .27-.184.8.8 0 0 1 .297-.053"
    />
  </>
)
export default EndedArrowUp
